// Equipos
export const FUTBOL_TEAMS = [
  { value: 'flamengo', label: 'Flamengo' },
  { value: 'liga de quito', label: 'Liga de Quito' },
  { value: 'palmeiras', label: 'Palmeiras' },
  { value: 'racing club', label: 'Racing Club' }
];

export const RUGBY_TEAMS = [
  { value: 'alumni', label: 'Alumni' },
  { value: 'belgrano athletic', label: 'Belgrano Athletic' },
  { value: 'buenos aires crc', label: 'Buenos Aires CRC' },
  { value: 'casi', label: 'CASI' },
  { value: 'cuba', label: 'CUBA' },
  { value: 'hindú', label: 'Hindú' },
  { value: 'la plata', label: 'La Plata' },
  { value: 'los tilos', label: 'Los Tilos' },
  { value: 'newman', label: 'Newman' },
  { value: 'regatas bella vista', label: 'Regatas Bella Vista' },
  { value: 'san luis', label: 'San Luis' },
  { value: 'sic', label: 'SIC' }
];

// Configuración compartida
export const SHARED_ESPN_CONFIG = {
  regions: [
    { value: 'arg/uru', label: 'ARG/URU' },
    { value: 'arg/cl', label: 'ARG/CL' },
    { value: 'col/pe', label: 'COL/PE' },
    { value: 'bo', label: 'BO' },
    { value: 'co', label: 'CO' },
    { value: 'cl', label: 'CL' },
    { value: 'mx', label: 'MX' }
  ],

  days: [
    { value: 'Domingo - en vivo', label: 'Domingo - en vivo' },
    { value: 'Lunes - en vivo', label: 'Lunes - en vivo' },
    { value: 'Martes - en vivo', label: 'Martes - en vivo' },
    { value: 'Miercoles - en vivo', label: 'Miercoles - en vivo' },
    { value: 'Jueves - en vivo', label: 'Jueves - en vivo' },
    { value: 'Viernes - en vivo', label: 'Viernes - en vivo' },
    { value: 'Sabado - en vivo', label: 'Sabado - en vivo' }
  ],

  channels: [
    { value: 'disney+', label: 'Disney+' },
    { value: 'espn y disney+', label: 'ESPN y Disney+' },
    { value: 'espn2 y disney+', label: 'ESPN2 y Disney+' },
    { value: 'espn, espn2 y disney+', label: 'ESPN, ESPN2 y Disney+' }
  ],

  regionOffsets: {
    'arg/uru': 0,
    cl: -1,
    'col/pe': -2,
    mx: -3
  }
};
